import { useState } from "react";
import { Button, Checkbox, Heading, HStack, Popover, Portal, Textarea } from "@chakra-ui/react";
import { LuEraser, LuMapPinned, LuPencil } from "react-icons/lu";
import { drawCoordinatesStringOnMap } from "../../../utilies/DrawingPoints";
import { useAppStore } from "../../../context/store";
import { Tooltip } from "../../ui/tooltip";

function ShowPoints() {
  const viewerRef = useAppStore((s) => s.viewerRef);

  const [coordinates, setCoordinates] = useState("");
  const [connection, setConnection] = useState(false);

  return (
    <Popover.Root positioning={{ placement: "left-start" }}>
      <Popover.Trigger asChild>
        <Button userSelect={"none"} p={0} bg={"Background"}>
          <Tooltip content="Coordinate Drawing">
            <LuMapPinned color="MenuText" />
          </Tooltip>
        </Button>
      </Popover.Trigger>
      <Portal>
        <Popover.Positioner>
          <Popover.Content>
            <Popover.Arrow />
            <Popover.Body p={2}>
              <Heading fontSize={"lg"}>Drawing Points</Heading>
              <Textarea
                placeholder="Coordinates"
                rows={5}
                value={coordinates}
                onChange={(v) => {
                  setCoordinates(v.target.value);
                }}
              />
              <Checkbox.Root checked={connection} onCheckedChange={(e) => setConnection(!!e.checked)} mb={3}>
                <Checkbox.HiddenInput />
                <Checkbox.Control />
                <Checkbox.Label>Connection</Checkbox.Label>
              </Checkbox.Root>
              <HStack gap={2}>
                <Button
                  onClick={() => {
                    drawCoordinatesStringOnMap(viewerRef.current, coordinates, connection);
                  }}
                >
                  <LuPencil />
                  Draw
                </Button>
                <Button
                  colorPalette={"red"}
                  onClick={() => {
                    drawCoordinatesStringOnMap(viewerRef.current, coordinates, connection, true);
                  }}
                >
                  <LuEraser />
                  Reset
                </Button>
              </HStack>
            </Popover.Body>
          </Popover.Content>
        </Popover.Positioner>
      </Portal>
    </Popover.Root>
  );
}

export default ShowPoints;
